import { DocumentShareForm } from '@noco/http-client/lib/noco'

export const convertSiteShareFormsToRequestType = (siteShareForms: DocumentShareForm[]) => {
  return siteShareForms.map(form => ({
    contactSettingId: form.contactSetting?.id,
    isRequired: form.isRequired
  }))
}

export const getEuSiteMetaTitle = ({
  siteTitle,
  organizationName,
  hideAd
}: {
  siteTitle?: string | null
  organizationName?: string
  hideAd?: boolean
}) => {
  // 広告非表示の場合には資料サイトタイトル + org 名を表示する
  if (hideAd) {
    return `${siteTitle || ''}${organizationName ? ` ${organizationName}` : ''}`
  }
}
